import './App.css';
import TalentPool from './components/TalentBoll/talentBoll'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
  return (
    <div className="App">
      <TalentPool />
    </div>
  );
}

export default App;
